import { defineMessages } from 'react-intl';

export default defineMessages({
  deactivatedSuccess: {
    id: 'employee.detail.deactivatedSuccess',
    defaultMessage: 'Employee telah di deactivated',
  },
  activatedSuccess: {
    id: 'employee.detail.activatedSuccess',
    defaultMessage: 'Employee telah di activated',
  },
  labelId: {
    id: 'employee.detail.form.label.ID',
    defaultMessage: 'Employee ID',
  },
  labelName: {
    id: 'employee.detail.form.label.Name',
    defaultMessage: 'Employee Name',
  },
  labelKtp: {
    id: 'employee.detail.form.label.Ktp',
    defaultMessage: 'Employee ID Card (KTP) Number',
  },
  labelUsername: {
    id: 'employee.detail.form.label.Username',
    defaultMessage: 'Employee Username',
  },
  labelPassword: {
    id: 'employee.detail.form.label.Password',
    defaultMessage: 'Employee Password',
  },
  labelPhoto: {
    id: 'employee.detail.form.label.Photo',
    defaultMessage: 'Employee Photo',
  },
  labelEmail: {
    id: 'employee.detail.form.label.Email',
    defaultMessage: 'Employee Email Address',
  },
  labelPhone: {
    id: 'employee.detail.form.label.Phone',
    defaultMessage: 'Employee Phone Number',
  },
  labelRoles: {
    id: 'employee.detail.form.label.Roles',
    defaultMessage: 'Employee Roles',
  },
  btnEdit: {
    id: 'employee.btn.edit',
    defaultMessage: 'Ubah',
  },
  btnDeactivated: {
    id: 'employee.btn.deactivated',
    defaultMessage: 'Non-aktifkan',
  },
  btnActivated: {
    id: 'employee.btn.activated',
    defaultMessage: 'Aktifkan',
  },
  breadcrumbList: {
    id: 'employee.list',
    defaultMessage: 'Employee List',
  },
  breadcrumbDetail: {
    id: 'employee.breadcrumb.detail',
    defaultMessage: 'Employee Detail',
  },
  title: {
    id: 'employee.detail.title',
    defaultMessage: 'Company Detail',
  },
});
